if (!customElements.get("reviews-controller")) {
  class ReviewsController extends HTMLElement {
    connectedCallback() {
      this.filterButtons = Array.from(
        this.querySelectorAll("[data-reviews-filter]")
      );
      this.reviewItems = Array.from(this.querySelectorAll("[data-tags]"));
      this.carousel = this.querySelector("site-carousel");
      this.isDesktop = window.matchMedia("(min-width: 1024px)").matches;
      this.initialCount = parseInt(
        this.getAttribute(
          this.isDesktop ? "data-initial-count" : "data-initial-count-mobile"
        ) || "4",
        10
      );

      // Select "All" pill by default
      const allButton = this.filterButtons.find(
        (btn) => btn.getAttribute("data-reviews-filter") === "all"
      );
      if (allButton) {
        allButton.classList.add("reviews-tag-selected");
      } else if (this.filterButtons.length) {
        this.filterButtons[0].classList.add("reviews-tag-selected");
      }

      // On desktop, normalize lg:hidden to hidden for JS control
      if (this.isDesktop) {
        this.reviewItems.forEach((item) => {
          if (item.classList.contains("lg:hidden")) {
            item.classList.remove("lg:hidden");
            item.classList.add("hidden");
          }
        });
      } else {
        // On mobile, remove all hidden classes — swiper handles visibility
        this.reviewItems.forEach((item) => {
          item.classList.remove("lg:hidden", "hidden");
        });
      }

      this.initShowMore();

      this.filterButtons.forEach((button) => {
        button.addEventListener("click", () => {
          if (!button.classList.contains("reviews-tag-selected")) {
            this.filterButtons.forEach((btn) =>
              btn.classList.remove("reviews-tag-selected")
            );
            button.classList.add("reviews-tag-selected");
            this.filterReviews();
          }
        });
      });
    }

    getSelectedReviewsFilter() {
      return (
        this.filterButtons
          .find((button) =>
            button.classList.contains("reviews-tag-selected")
          )
          ?.getAttribute("data-reviews-filter") || null
      );
    }

    filterReviews() {
      const selectedFilter = this.getSelectedReviewsFilter();

      this.reviewItems.forEach((item) => {
        const itemTags = item.getAttribute("data-tags").split(",");
        const shouldShow =
          !selectedFilter ||
          selectedFilter === "all" ||
          itemTags.includes(selectedFilter);

        item.style.display = shouldShow ? "" : "none";
      });

      // On desktop, reset show-more after filtering
      if (this.isDesktop) {
        this.resetShowMore();
      }

      // On mobile, update swiper
      if (!this.isDesktop && this.carousel && this.carousel.swiper) {
        this.carousel.swiper.slideTo(0, 0);
        this.carousel.swiper.update();
      }
    }

    initShowMore() {
      this.showMoreBtn = this.querySelector("[data-show-more-btn]");
      if (this.showMoreBtn) {
        this.showMoreBtn.addEventListener("click", () => this.showMore());
      }
      if (this.isDesktop) {
        this.updateShowMoreButton();
      }
    }

    resetShowMore() {
      let visibleIdx = 0;
      this.reviewItems.forEach((item) => {
        if (item.style.display === "none") return;
        if (visibleIdx >= this.initialCount) {
          item.classList.add("hidden");
        } else {
          item.classList.remove("hidden");
        }
        visibleIdx++;
      });
      this.updateShowMoreButton();
    }

    showMore() {
      const hiddenCards = this.reviewItems.filter(
        (item) =>
          item.classList.contains("hidden") && item.style.display !== "none"
      );
      hiddenCards.forEach((card) => card.classList.remove("hidden"));
      this.updateShowMoreButton();
    }

    updateShowMoreButton() {
      const wrapper = this.querySelector("[data-show-more-wrapper]");
      if (!wrapper) return;

      const visibleCards = this.reviewItems.filter(
        (item) => item.style.display !== "none"
      );
      const hiddenCards = visibleCards.filter((item) =>
        item.classList.contains("hidden")
      );

      const remainingEl = wrapper.querySelector("[data-remaining-count]");
      if (remainingEl) remainingEl.textContent = hiddenCards.length;

      wrapper.style.display = hiddenCards.length === 0 ? "none" : "";
    }
  }

  customElements.define("reviews-controller", ReviewsController);
}
